import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from './redux';

class Meta extends Component {

  componentDidMount() {
    const { title } = this.props;
   // document.title = this.getTitle(title);
    const metaInfo=this.getMeta(title)
    document.title = metaInfo.title;
    let meta = document.getElementsByTagName("meta");
    meta[3]["content"] = metaInfo.keywords;
    meta[4]["content"] = metaInfo.description;
  }

  componentDidUpdate() {
    const { title } = this.props;
    // document.title = this.getTitle(title);
    // const metaInfo=this.getMeta(title)
    // document.title = metaInfo.title;
    // let meta = document.getElementsByTagName("meta");
    // meta[3]["content"] = metaInfo.keywords;
    // meta[4]["content"] = metaInfo.description;
  }

  getTitle(title) {
    return `${title ? (title + '-') : ''}中腾信-专注获客与风控的金融科技服务商`
  }

  getMeta(){
    const {announcement,job,news,location,menus}=this.props
    let pathname=location.pathname
    //let locationsss=window.location
   // const currentRouter=pathname.substr(pathname.lastIndexOf('/') + 1 )
   const pathnames=pathname.split('/')
   const currentRouter=pathnames[1].toLowerCase()
   const childerRouter=pathnames.length>=3?pathnames[2].toLowerCase():''
    let metaInfo={}
    const locationSplit =(pathnames.length>3?pathnames[3].toLowerCase():'').split('.')
    let newsId
    if(locationSplit.length>1){
      newsId = locationSplit[0].split('-')[1]
    }else{
      newsId = locationSplit[0]
    }

    let mobileAgent=''
    if(pathname=='/'){
      mobileAgent="https://m.chinatopcredit.com/"
    }else if(pathname=='/aboutUs/company'){
      mobileAgent="https://m.chinatopcredit.com/company-intro"
    }else if(pathname=='/aboutUs/management'){
      mobileAgent="https://m.chinatopcredit.com/leader-team"
    }else if(pathname=='/recruitment/jobRecruitment'){
      mobileAgent="https://m.chinatopcredit.com/recruitment"
    } else if(pathnames.length>=4 && pathnames[2]=='newsinfo'){
      let newsInfoPage=pathnames[3].split(/[\.\/\-]/)[1]
      mobileAgent="https://m.chinatopcredit.com/news/"+newsInfoPage
    }else if(pathnames.length>=4 && pathnames[2]=='news'){
      let newsPage=pathnames[3].split(/[\.\/\-]/)[1]
      mobileAgent="https://m.chinatopcredit.com/news/detail/"+newsPage
    }
    metaInfo.mobileAgent=mobileAgent


    menus.forEach((menusItem,key) => {
      if((menusItem.catname=='home'?"":menusItem.catname.toLowerCase())==currentRouter && metaInfo.title==undefined) {
        if( metaInfo.title!=undefined){
          return false
      }
        if(!menusItem.children){
          metaInfo.title=menusItem.seo_title
          metaInfo.keywords=menusItem.seo_keywords
          metaInfo.description=menusItem.seo_description
          return
        }else{
          if(pathnames.length>=4 && !/^(newsinfo|loaninfo|announcement|recruitment)$/.test(childerRouter)){
            //pathnames[3]
            if(childerRouter=='news' || childerRouter=='loaninfodetail'){
            metaInfo.title=news.currentData.title+'-中腾信'
            metaInfo.keywords=news.currentData.tag
            metaInfo.description=news.currentData.description
            }else if(childerRouter=='announcementdetail'){
              metaInfo.title=announcement.currentData.title+"-中腾信"
              metaInfo.keywords=announcement.currentData.tag
              metaInfo.description=announcement.currentData.description
            }else if(childerRouter=='jobdetail'){
              metaInfo.title=job.name+'-中腾信'
              metaInfo.keywords="职位招聘,广纳贤才,中腾信"
              metaInfo.description="中腾信面为求职者提供最新最全最准确的招聘信息, 面向全国广纳贤才,欢迎您成为中腾信的一员!地址:上海市虹口区四川北路859号中信广场18楼1805室,HR联系电话:021-35967521."
            }
            return false
          }

          menusItem.children.forEach((item,key) => {
          //menusItem.children.map(item=>{
            if(pathnames.length>=3 && (item.catname.toLowerCase()==childerRouter || (childerRouter=='newsinfo'&& item.catname.toLowerCase()=='news'))){
              let page=/^(newsinfo|loaninfo)$/.test(childerRouter)?"_Part"+newsId+"_中腾信":''
              metaInfo.title=item.seo_title+page
              metaInfo.keywords=item.seo_keywords
              metaInfo.description=item.seo_description
              return
            }
            else if(metaInfo.title==undefined){
              metaInfo.title=menusItem.children[0].seo_title
              metaInfo.keywords=menusItem.children[0].seo_keywords
              metaInfo.description=menusItem.children[0].seo_description
              return
            }
          })
          return
        }
      }
  })
  if(metaInfo.title==undefined){
    metaInfo.title="中腾信-专注获客与风控的金融科技服务商"
    metaInfo.keywords="中腾信-专注获客与风控的金融科技服务商"
    metaInfo.description="中腾信-专注获客与风控的金融科技服务商"
  }

  return metaInfo
  }

  render() {
    const { setMeta, title, ...props } = this.props;
    const metaInfo=this.getMeta(title)
    this.props.setMeta({...props, title: metaInfo.title,
      keywords:metaInfo.keywords,
      description:metaInfo.description,
      mobileAgent:metaInfo.mobileAgent,
    });

    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    menus: state.common.menus,
    news: state.aboutUs.news,
    announcement: state.aboutUs.announcement,
    job:state.recruitment? state.recruitment.job:[]
  }
}

Meta = connect(mapStateToProps, { setMeta: actions.setMeta })(Meta);

export default Meta;



// WEBPACK FOOTER //
// ./components/layout/Meta.js